import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-whatsapp-float',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './whatsapp-float.html',
  styleUrl: './whatsapp-float.scss'
})
export class WhatsAppFloat {
  
  // Número de WhatsApp de la empresa (cambiar según sea necesario)
  private readonly whatsappNumber = '963258147'; // +51 963 258 147
  
  // Mensaje predeterminado que se enviará
  private readonly defaultMessage = 'Hola! Me interesa conocer más sobre La Joya Park Resort. ¿Podrían brindarme más información?';
  
  /**
   * Abre WhatsApp con el número y mensaje predeterminado
   */
  openWhatsApp(): void {
    const encodedMessage = encodeURIComponent(this.defaultMessage);
    const whatsappUrl = `https://wa.me/${this.whatsappNumber}?text=${encodedMessage}`;
    
    // Abrir en nueva pestaña
    window.open(whatsappUrl, '_blank');
  }
}
